// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"gesture-down"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M11.7502 15V19.5C11.7502 20.6046 12.6456 21.5 13.7502 21.5C14.8548 21.5 15.7502 20.6046 15.7502 19.5L15.7502 9.5L19.5813 10.3514C19.9845 10.4409 20.4012 10.2735 20.6303 9.92987L21.2502 9L16.8507 3.28058C16.4721 2.78841 15.8863 2.5 15.2654 2.5L7.19173 2.5C6.33087 2.5 5.56659 3.05086 5.29436 3.86754L3.264 9.95864C2.96464 10.8567 3.33592 11.8417 4.15362 12.3187L8.28317 14.7276C8.58904 14.906 8.9368 15 9.29091 15L11.7502 15Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M11.7502 15V19.5C11.7502 20.6046 12.6456 21.5 13.7502 21.5C14.8548 21.5 15.7502 20.6046 15.7502 19.5L15.7502 9.5L19.5813 10.3514C19.9845 10.4409 20.4012 10.2735 20.6303 9.92987L21.2502 9L16.8507 3.28058C16.4721 2.78841 15.8863 2.5 15.2654 2.5L7.19173 2.5C6.33087 2.5 5.56659 3.05086 5.29436 3.86754L3.264 9.95864C2.96464 10.8567 3.33592 11.8417 4.15362 12.3187L8.28317 14.7276C8.58904 14.906 8.9368 15 9.29091 15L11.7502 15Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const GestureDownIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'gesture-down',
    ref,
    icon: element,
  },
));

GestureDownIcon.displayName = 'GestureDownIcon';

export default GestureDownIcon;
